export const expositionsSlider = () => {

  if ($('#itg-expositions-navigation').length != -1) {



    const $navigation = $('#itg-expositions-navigation');

    const $next = $('#itg-expositions-navigation .next');
    const $prev = $('#itg-expositions-navigation .prev');

    const $imagesContainer = $('#itg-expositions-images');
    const $informationContainer = $('#itg-expositions-information');

    let images = $imagesContainer.find('.exposition');
    let informations = $informationContainer.find('.exposition-info');

    let currentIndex = 0;
    let maxIndex = $navigation.data('maxindex');

    console.log(maxIndex);


    const slide = (action = 'next') => {

      images.hide();
      informations.hide();

      if (action == 'next') {
        currentIndex != maxIndex ? currentIndex = Math.min( (currentIndex + 1), maxIndex ) : currentIndex = 0;
      } else {
        currentIndex != 0 ? currentIndex-- : currentIndex = maxIndex;
      }

      images.filter('[data-key="' + currentIndex + '"]').show();
      informations.filter('[data-key="' + currentIndex + '"]').show();

console.log(images.filter('[data-key="' + currentIndex + '"]'));
    }

    $next.click(function(e) {
      e.preventDefault();
      slide('next');
    });

    $prev.click(function(e) {
      e.preventDefault();
      slide('prev');
    });


  }

}
